<mat-card-header class="justify-content-center">
  <mat-card-title class="card-title">{{info?.fundraiser_image?.placeholder}}</mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content>
  <div class="form-container">
    <div class="title-container">
      <label for="fImage"><strong>{{info?.fundraiser_image?.placeholder}}</strong>
        <div class="optional-text">{{info?.optional}}</div>
      </label>
      <app-popover class="app-popover" *ngIf="isMedical" [info]="{desc:'Images of kids will be blurred as per Govt Regulation and platform compliance.'}"></app-popover>
    </div>
    <div class="text-center loader-image-holder style-as-link">
      <div class="loader-image-clickable"  (click)="openDialog(optionsDialog)">
        <img loading="lazy" class="img-preview" [src]="croppedImage?.fImage" id="fImagePre" [hidden]="!croppedImage?.fImage" alt="fundraiser cropped image"  data-gumlet="false">
        <img loading="lazy" class="img-preview loader-img" data-src="/assets/images/medical-fr/image-loader.jpg" id="fImagePre" [hidden]="croppedImage?.fImage" alt="fundraiser image loader">
      </div>
    </div>
    <div class="image-input">
      <input #fImage type="file" name="fImage" id="fImage" accept="image/*" (change)="fileChangeEvent($event, 'fImage')" style="display: none">
      <button mat-raised-button type="button" (click)="openDialog(optionsDialog)" >
        <mat-icon class="icon icon-camera icon-primary"></mat-icon> {{info?.choose_file}}
      </button>
      <span class="ml-10" *ngIf="media?.fImage?.name">{{media?.fImage?.name}}</span>
    </div>
  </div>
  <div *ngIf="false" class="form-container"> <!-- *ngIf="isUploadBeneficiary" -->
    <div class="title-container">
      <label for="fImage"><strong>{{info?.beneficiary_image?.placeholder}}</strong></label>
      <!-- <app-popover [info]="info.beneficiary_image.popover"></app-popover> -->
    </div>
    <img loading="lazy" class="img-preview beni-img" [src]="croppedImage?.bImage" id="bImagePre" alt="beneficiary cropped image"  data-gumlet="false"/>
    <div class="image-input">
      <input type="file" name="fImage" id="bImage" accept="image/*" (change)="fileChangeEvent($event, 'bImage')" style="display: none">
      <button mat-raised-button type="button" (click)="openFile('bImage')" >
        <mat-icon class="icon icon-camera icon-primary"></mat-icon> {{info?.choose_file}}
      </button>
      <span class="ml-10" *ngIf="media?.bImage?.name">{{media?.bImage?.name}}</span>
    </div>
  </div>
  <div class="flex-conatiner" *ngIf="isSubmit">
    <span class="error-message">* Please upload required files</span>
  </div>
  <form class="form-container m-10" [formGroup]="advanceForm" autocomplete="off">
    <mat-form-field class="input-container">
      <input matInput appPlaceAutocomplete placeType="(cities)" [placeholder]="info?.city?.placeholder" formControlName="city" (onSelect)="getPlace($event)">
      <mat-icon class="icon-city" matSuffix></mat-icon>
      <mat-error *ngIf="city?.invalid">{{info?.fieldRequired}}</mat-error>
    </mat-form-field> <!-- City-ends -->
  </form>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" > {{info?.save_and_continue}} </button>
</mat-card-footer>

<!-- Image modal -->
<ng-template #imageDialogTemplate>
  <section class="upload-info">
    <span class="info-txt">This is the image that will feature right on top of your page. Make it impactfull!</span>
    <span class="info-txt">Filetype: PNG, JPG, BMP</span>
    <span>Recommended Size: 700x400</span>
  </section>
  <mat-dialog-content #cropperDialogContent class="flex-container cropper-content mt-30" >
    <div *ngIf="!fileError?.error" class="crp-contanier">
      <angular-cropper #cropper [cropperOptions]="options" [imageUrl]="imgSrc"></angular-cropper>
    </div>
    <div *ngIf="!fileError?.error" class="drag-text">
      <mat-icon>zoom_out_map</mat-icon> Drag to Reposition
    </div>
    <div *ngIf="fileError?.error" class="error-display">
      <mat-icon class="icon-info"></mat-icon>
      <p class="text-center"><small><em>{{fileError?.message}}</em></small></p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions cdkFocusRegionstart>
    <div *ngIf="!fileError?.error" class="flex-container full-width">
      <div>
        <button mat-icon-button (click)="zoom('0.1')" ><mat-icon class="icon-plus control-icon"></mat-icon></button>
        <button mat-icon-button (click)="zoom('-0.1')"><mat-icon class="icon-minus control-icon"></mat-icon></button>
      </div>
      <div>
        <button mat-button color="primary" (click)="closeDialog()">CANCEL</button>
        <button mat-raised-button class="save-btn" color="primary" [disabled]="isSpin" (click)="save()">Save</button>
      </div>
    </div>
    <div *ngIf="fileError?.error" class="flex-container1">
      <button mat-raised-button class="choose-btn" type="button" (click)="openFile('fImage')" >CHOOSE ANOTHER IMAGE</button>
    </div>
  </mat-dialog-actions>
</ng-template>

<!-- image/video upload oprions dialog -->
<ng-template #optionsDialog>
  <div class="dialog-container">
    <div class="dialog-header option-header">
      <button (click)="closeDialog()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content class="upload-options" cdkFocusRegionstart>
      <div class="options">
        <button class="option-btn" mat-button (click)="openFile('fImage')">
          <mat-icon class="icon-image op-icon" matPrefix>&nbsp;</mat-icon> Choose image from Gallery
        </button>
        <div class="line"></div>
        <!-- <button class="option-btn" mat-button (click)="selectFromFacebook()">
          <mat-icon class="icon-fb op-icon" matPrefix>&nbsp;</mat-icon> Choose from Facebook
        </button>
        <div class="line"></div> -->
        <button class="option-btn" mat-button (click)="openDialog(videoUrlDialog)">
          <mat-icon class="icon-video op-icon" matPrefix>&nbsp;</mat-icon> Enter Video Url
        </button>
      </div>
    </mat-dialog-content>
  </div>
</ng-template>

<ng-template #videoUrlDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <button (click)="closeDialog()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content>
      <mat-form-field [color]="isVideoUrl?'warn':'primary'" class="input-container">
        <input matInput placeholder="Enter Video URL" [(ngModel)]="videoUrl" >
      </mat-form-field>
      <small class="error-message" *ngIf="isVideoUrl">Please enter a valid Youtube url!</small>
    </mat-dialog-content>
    <mat-dialog-actions class="flex-container1">
      <button mat-button color="primary" (click)="closeDialog()">CANCEL</button>
      <button mat-raised-button class="save-btn" color="primary" (click)="saveVideoURL()">Save</button>
    </mat-dialog-actions>
  </div>
</ng-template>
